import React from 'react'
import useAxios from 'axios-hooks'
import { connect } from 'react-redux'
import { SubmissionError, reset } from 'redux-form'
import history from 'configureHistory'

import Form from './Form'

const ForgotPasswordPage = (/* { reset: resetForm } */) => {
	const [, executePost] = useAxios(
		{
			url: 'auth/request-password-reset',
			method: 'POST',
		},
		{ manual: true }
	)

	const handleSubmit = async ({ email }) => {
		try {
			await executePost({ data: { email } })

			// resetForm('forgotPassword')

			history.replace({
				pathname: '/login',
				state: {
					loginMessage: 'forgot_password_sent_text',
				},
			})
		} catch (error) {
			throw new SubmissionError({
				// email: 'User does not exist',
				_error: error.response.data.message,
			})
		}
	}

	return <Form onSubmit={handleSubmit} />
}

export default connect(null, {
	reset,
})(ForgotPasswordPage)
